import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import {
  DownloadOutlined,
  LeftOutlined,
  RightOutlined,
  RotateLeftOutlined,
  RotateRightOutlined,
  SwapOutlined,
  UndoOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
} from '@ant-design/icons';
import { 
  AiOutlineEye,
  AiOutlineClose,
  AiOutlineRotateLeft,
  AiOutlineRotateRight,
  AiOutlineZoomIn, 
  AiOutlineZoomOut,
  AiOutlineSwap,
  AiOutlineArrowLeft,
  AiOutlineArrowRight,
  AiOutlineFilePdf
} from 'react-icons/ai';
import { Image, Space } from 'antd';
const LeaveAttachment = ({fields, remove}) => {

  const handleDownloadAll = (data) => {
    
   
        if (!data || data.length === 0) {
            alert("No attachments available to download.");
            return;
          }
        
         
        
            // Create a temporary anchor element for downloading
            const link = document.createElement('a');
            link.href = data.url;
            link.target = "_blank";
        
            // Set file name or fallback to URL file name
            link.download = data.name || data.url.split('/').pop();
        
            // Trigger download
            document.body.appendChild(link);
            link.click();
        
            // Clean up the DOM
            document.body.removeChild(link);
         
 

  };

  // Filter out images from attachments
  // const imageAttachments = fields?.filter(item => {
  //   const extension = item?.url.split(".").pop().toLowerCase();
  //   return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension);
  // }) || [];

  return (
    <>
      <div className="mail-attachments">
        <Image.PreviewGroup
          preview={{
            toolbarRender: (
              _,
              {
                transform: { scale },
                actions: {
                  onActive,
                  onFlipY,
                  onFlipX,
                  onRotateLeft,
                  onRotateRight,
                  onZoomOut,
                  onZoomIn,
                  onReset,
                  onClose
                },
              },
            ) => (
              <Space size={12} className="toolbar-wrapper">
                <AiOutlineArrowLeft onClick={() => onActive?.(-1)} />
                <AiOutlineArrowRight onClick={() => onActive?.(1)} />
                {/* <DownloadOutlined onClick={onDownload} /> */}
                <AiOutlineSwap rotate={90} onClick={onFlipY} />
                <AiOutlineSwap onClick={onFlipX} />
                <AiOutlineRotateLeft onClick={onRotateLeft} />
                <AiOutlineRotateRight onClick={onRotateRight} />
                <AiOutlineZoomOut disabled={scale === 1} onClick={onZoomOut} />
                <AiOutlineZoomIn disabled={scale === 50} onClick={onZoomIn} />
                <AiOutlineClose onClick={onClose} />
                {/* <AiOutlineUndo onClick={onReset} /> */}
              </Space>
            ),
            // onChange: (index) => {
            //   setCurrent(index);
            // },
          }}
        >
          <ul className="d-flex">
            {fields?.length > 0 ? (
              <>
                {fields?.map((item, index) => (
                  <ListItem
                    id={item.id}
                    key={index}
                    item={item}
                    download={handleDownloadAll}
                    remove={remove}
                    index={index}
                    // allImages={imageAttachments}
                  />
                ))}
              </>
            ) : (
              <div></div>
            )}
          </ul>
        </Image.PreviewGroup>
      </div>
    </>
  );
};

export const ListItem = ({ item, key, remove, index,  }) => {
  console.log(index, "LLL");
  const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(item?.url.split(".").pop().toLowerCase());
  
  return(
    <li className="d-flex me-3">
      <div className="attach-file">
        {
          console.log(isImage, "eeee")
        }
        {
          item?.url.split(".").pop() == "pdf" ? (
            <i className="fa-solid fa-file-pdf" style={{fontSize: 20}}></i>

          ) : 
          item?.url.split(".").pop() == "docx" ? (
            <i className="fa-solid fa-file-word" style={{fontSize: 20}}></i>
          ) :
          item?.url.split(".").pop() == "doc" ? (
            <i className="fa-solid fa-file-word" style={{fontSize: 20}}></i>
          ) :
          
          (
            isImage ? (
              <Image
                style={{ height: 40, width: 40, display: 'none' }}
                src={item.url}
                alt=""
                preview={{
                  src: item.url,
                  mask: null,
                }}
              />
            ) : (
              <></>
            )
          )
        }
        
        {/* Show preview thumbnail for all types */}
        {
          console.log(isImage, "11111")
        }
        {
          isImage ? (
            <img style={{ height: 40, width: 40 }} src={item.url} alt="" />
          ) : (
            <></>
          )
        }
        
      </div>
      <div className="attach-info align-right d-flex justify-content-start align-items-start flex-column">
        {" "}
        <Link className="attach-filename ms-1" onClick={() => remove(index)}>
          <i className="fa-solid fa-times"/>
        </Link>
        
        {isImage ? (
          <Link 
            className="attach-filename ms-1"
            onClick={() => {
              // Find the corresponding Image component and trigger its preview
              document.querySelector(`[src="${item.url}"]`)?.click();
            }}
          >
            <i style={{fontSize: 10}} className="fa-solid fa-eye me-2"/>
          </Link>
        ) : (
          <Link 
            className="attach-filename ms-1" 
            to={item.url} 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <i style={{fontSize: 10}} className="fa-solid fa-eye me-2"/>
          </Link>
        )}
      </div>
    </li>
  );
};

export default LeaveAttachment;
